module.exports = __webpack_public_path__ + "media/images/icons/human_anatomy_icon-42edc4b8414accca9e28f96b1be7f086.svg";